<div class="container-fluid hero-background darkbg">
  <div class="hero-container">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="white">
            drug procurement designed<br class="d-none d-md-block" />
            by industry experts.
          </h2>
          <h3 class="yellow">MEET THE MEDIGI TEAM</h3>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid second-container">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-xl-6 pb-5">
        <img
          class="second-container-image"
          src="assets/img/logos/medigi-logo-blue.svg"
          alt="medigi-logo"
        />
      </div>
      <div class="col-12 col-xl-6">
        <h3 class="green">GET TO KNOW US</h3>
        <h2 class="mdg-blue">who is medigi?</h2>
        <p class="blue">
          The medigi team has a diverse and accomplished roster comprised of
          business leaders, software architects, programmers, pharmacy
          professionals, data engineers, financial analysts, artists, STEM
          experts, teachers, and families.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid third-container">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-xl-6">
        <h3 class="green">THE EVOLUTION OF MEDIGI</h3>
        <h2 class="mdg-blue">the future of drug procurement</h2>
        <p class="blue">
          In 2015, MedShorts was created to fill a unique niche in the market
          and bring cost savings to pharmacies while providing a sustainable
          option for manufacturers to sell short-dated medicines at a discount.
        </p>
        <p class="blue">
          MedShorts’ growth was purely a grassroots effort based on
          relationships with both pharmacies and manufacturers. By 2020, our
          customer base wanted more from our online marketplace — we saw a need
          to expand the offerings to full-dated and compounded medications from
          pharmaceutical suppliers across the nation.
        </p>
        <p class="blue">
          Our team got to work and launched medigi in 2021 to serve as the
          parent platform to MedShorts and our third channel, 503B.com.
        </p>
      </div>
      <div class="col-12 col-xl-6 px-0 px-md-3">
        <div>
          <video autoplay loop [muted]="'muted'">
            <source
              src="/assets/img/static-pages/medigi/videos/poppers-web.mp4"
              type="video/mp4"
            />
          </video>
          <!-- <app-timeline-card></app-timeline-card> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row justify-content-center">
    <app-large-card
      class="billboard col-lg-10 col card-offset-bottom"
      [pageLocation]="'about-us'"
      [cardType]="'button'"
    ></app-large-card>
  </div>
</div>

<div class="container-fluid fourth-container">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="white">meet the team</h2>
        <app-employee-card></app-employee-card>
      </div>
    </div>
  </div>

  <div class="container-fluid fifth-container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-xl-6">
          <h2 class="white">
            medigi is proud to have<br />
            team members across<br />
            the country and beyond!
          </h2>
        </div>
        <div class="col-12 col-xl-6">
          <app-city-badges></app-city-badges>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid sixth-container">
  <div class="container">
    <div class="row align-items-center justify-content-between">
      <div class="col-12 col-xl-4">
        <h3 class="yellow">WHERE IS MEDIGI?</h3>
        <h2 class="white">life in our office</h2>
        <p class="white">
          Headquarted in Orlando, FL, there’s always something to celebrate at
          medigi! Whether we’re toasting new personal wins or cheering on
          medigi’s next move, our team works and laughs together.
        </p>
      </div>
      <div class="col-12 col-xl-8">
        <div class="culture-images">
          <div>
            <img
              src="/assets/img/static-pages/medigi/v2-images/office-images/culture9.jpg"
              alt=""
            />
          </div>
          <div>
            <img
              src="/assets/img/static-pages/medigi/v2-images/office-images/culture5.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid seventh-container">
  <div class="container">
    <div class="row mb-5">
      <div class="col-12 col-xl-5">
        <h2 class="mdg-blue">
          we Rx-cited<br class="d-block d-md-none" />
          to meet you
        </h2>
        <p class="blue mb-4">
          Reserve a time for an office visit.<br /><b class="mdg-blue"
            >200 E Robinson St Suite 1250, Orlando, FL 32801</b
          >
        </p>
        <p class="mdg-blue mb-4">
          <b
            >You may reach out to us through email at
            <span class="green">info"&#64;medigi.com</span> or by phone,
            <span class="green">(844) 733-5633</span></b
          >
        </p>
        <p class="mdg-blue side-bar pl-2"><b>Phone shy?</b></p>
        <p class="blue mb-4">
          Connect to our messaging tool below, and a representative will reach
          out via our live web chat.
        </p>
        <app-button
          [buttonType]="'button'"
          [buttonText]="'connect now'"
          [buttonIcon]="'chevronright'"
          [buttonColor]="'green'"
          (click)="openChat()"
          (click)="sendToGa('Opened Chat', 'Manufacturer')"
          [buttonLink]="'do-nothing'"
        ></app-button>
      </div>
      <div class="col-12 col-xl-7">
        <div class="office-images">
          <img
            class="office-image-one"
            src="/assets/img/static-pages/medigi/v2-images/office-images/office1.jpg"
            alt=""
          />
          <img
            class="office-image-two"
            src="/assets/img/static-pages/medigi/v2-images/office-images/office2.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-xl-6">
        <h3 class="green">CHANGING THE WORLD OF DRUG PROCURMENT</h3>
        <h2 class="mdg-blue pb-3">want to join the medigi team?</h2>
        <app-static-form formType="career"></app-static-form>
      </div>
    </div>
  </div>
</div>
